import { extend } from 'sk-ui/lib/utils/util.js'

import blackListForm from './metaData/blackListForm'

export default {
  SoftwareBlackListCreate({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: blackListForm,
      props
    })
  },
  SoftwareBlackListEdit({ commit }, params) {
    const props = {
      title: '编辑黑名单',
      params: {
        id: params.rowIds[0]
      }
    }
    const editForm = extend(true, {}, blackListForm)
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  }
}
